import * as React from "react";
import AdminImportExternalKeyPage from "../../src/Admin/AdminExternalKey/AdminImportExternalKeyPage";
import { PageContainer } from "../../src/Basic/PageContainer";
import { TextContainer } from "../../src/Basic/TextContainer";
export default function AdminImportExternalRoute() {
  return (
    <PageContainer>
      <TextContainer maxWidth="sm">
        {/* <AdminCheck fallback={<div>not admin</div>}> */}
        <AdminImportExternalKeyPage></AdminImportExternalKeyPage>
        {/* </AdminCheck> */}
      </TextContainer>
    </PageContainer>
  );
}
